module.exports = __webpack_public_path__ + "img/add_invoice_item.268f1cf2.svg";